import { GDSInteractiveTokens } from '@leagueplatform/genesis-core';

// Use interactive colours for interactive components (other than buttons) like links, focus indicators, and selection controls.
const interactive: GDSInteractiveTokens = {
  background: {
    default: '#FFFFFF',
    disabled: '#F0F0F0',
    hovered: '#F8F8F8',
    pressed: '#F0F0F0',
  },
  action: {
    primary: '#501CD2',
    hovered: '#37209A',
    pressed: '#251669',
    subdued: '#66686B',
    disabled: '#D6D6D6',
  },
  border: {
    default: '#949494',
    disabled: '#D6D6D6',
    hovered: '#501CD2',
    critical: {
      default: '#BA1B3B',
    },
  },
  icon: {
    default: '#FFFFFF',
    disabled: '#949494',
  },
  focus: {
    inner: '#501CD2',
    outer: '#501CD2',
  },
};

export const interactiveTokens = {
  interactive,
};
